export default __webpack_public_path__ + "static/media/litao.png.webp";